import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacyPolicy.component.html',
  styleUrls: ['./privacyPolicy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {
  @Input() lang: any
  
  platform: any

  ngOnInit(): void {
    this.platform = localStorage.getItem('platform');
  }

}
